<div fxLayout="column" fxLayoutAlign="center center" style="margin: auto">
	<mat-icon style="font-size: 100px; width: 100px; height: 100px">engineering</mat-icon>
	<div class="h3 pt3">We're sorry... the portal is currently undergoing maintenance. We will be back soon!</div>
</div>
